import { render, staticRenderFns } from "./ElementsQuestionTable.vue?vue&type=template&id=b29c33f8&"
import script from "./ElementsQuestionTable.vue?vue&type=script&lang=js&"
export * from "./ElementsQuestionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports